import React from "react";
import { useSelector } from "react-redux";
import Post from "./Post";

export default function PostList() {
  const { filter } = useSelector((state) => state);
  console.log("file: PostList.jsx ~ line 7 ~ PostList ~ filter", filter)
  const { filteredPosts } = filter;
  const { posts } = useSelector((state) => state);
  console.log(
    "file: PostList.jsx ~ line 7 ~ PostList ~ state",
    filteredPosts,
    posts
  );
  return (
    <div className="mt-12 max-w-lg mx-auto grid gap-5 lg:grid-cols-3 lg:max-w-none">
      {filteredPosts.length > 0 ? (
        filteredPosts.map((post) => <Post key={post.id} data={post} />)
      ) : (
        <h1>No Post Found!</h1>
      )}
    </div>
  );
}
